module.exports = __webpack_public_path__ + "../resources/img/ic_installation_manual.8beae9e7.svg";